import TriggeredHookContextDecorator from "../../../App/Compositions/TriggeredHookContextDecorator";
import useResilientCreateMedicalNonCanContactResult from "../Hooks/useResilientCreateMedicalNonCanContactResult";

/** Decorate the {@link useResilientCreateMedicalNonCanContactResult} hook, providing context-aware parameters. */
const ComposedUseCreateMedicalNonCanContactResult = TriggeredHookContextDecorator(
  useResilientCreateMedicalNonCanContactResult,
  ({ contactId, patient, disqualifyingReasonsCState }) => ({
    contactId: contactId,
    patientId: patient.id,
    patientLeadId: patient.lead.id,
    disqualifyingReasons: disqualifyingReasonsCState || []
  })
);

export default ComposedUseCreateMedicalNonCanContactResult;
